<template>
  <v-container class="component_main pb-0 mb-0 px-8">
    <v-row>
      <v-col>
        <h1>Dashboard de monitoramento</h1>
        <p>Acompanhe as solicitações de autorização de atendimento e as transações conforme a situação delas.</p>
      </v-col>
      </v-row>
     
    <FilterByPrestadorOperadora
    :filter="(formData) => getDadosMonitoramento(formData)"
    :filtrarPorCarteiras="filtrarPorCarteiras"
    modulo_operadora="autorizador"
    />
      <v-row>
      <v-tabs v-model="tab" @change="mudarAba" class="elevation-0 px-3">
        <v-tab >Diário</v-tab>
        <v-tab >Mensal</v-tab>
        <!-- <v-tab @click="$router.push('/statusdasoperadoras')">Conectividade</v-tab> -->
        <v-tabs-items v-model="tab" style="min-height:60vh">
          <v-tab-item><MonitorPorPeriodo periodo="dia" title="Dia" :tab="tab" :dataReferencia="dataReferencia" :autorizacoes="autorizacoes.dia" :transacoes="transacoes.dia" :visaoDetalhada="visaoDetalhada" :setFilter="(filtro)=>atualizarFiltro(filtro, true)" /></v-tab-item>
          <v-tab-item><MonitorPorPeriodo periodo="mes" title="Mês" :tab="tab" :dataReferencia="dataReferencia" :autorizacoes="autorizacoes.mes" :transacoes="transacoes.mes" :visaoDetalhada="visaoDetalhada" :setFilter="(filtro)=>atualizarFiltro(filtro, true)"/></v-tab-item>
        </v-tabs-items>
          <v-spacer></v-spacer>
          <v-switch
            v-model="visaoDetalhada"
            :label="'Visão detalhada'"
            color="primary"
            class="mr-0"
            ></v-switch>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex"
import MonitorPorPeriodo from "@/components/autorizador/dashboard_de_monitoramento/MonitorPorPeriodo";
import FilterByPrestadorOperadora from "@/components/autorizador/common/FilterByPrestadorOperadora";
export default {
  components: {
    MonitorPorPeriodo,
    FilterByPrestadorOperadora
  },
  data() {
    return {
      dataReferencia: null,
      filterData: null,
      filtrarPorCarteiras: false,
      autorizacoes:{
        mes: [],
        dia: []
      },
      transacoes:{
        mes: [],
        dia: []
      },
      tab: 0,
      visaoDetalhada: false,
      // payload:{ 
      //     "data_referencia": "2021-09-14T16:17:25.202275-03:00",
      //     "autorizacoes": [{
      //     "operadora_id": "5711",
      //     "autorizadas": 10,
      //     "autorizadas_parcialmente": 11,
      //     "em_analise": 12,
      //     "aguardando_dados_prestador": 13,
      //     "negadas": 14,
      //     "canceladas": 15,
      //     "sem_resposta": 16,
      //     "total":80
      //   }],
      //   "transacoes": [{
      //     "operadora_id": "5711",
      //     "envio_anexos": 11,
      //     "procedimentos": 12,
      //     "status_autorizacao": 13,
      //     "elegibilidade": 14,
      //     "cancelamento_guia": 15,
      //     "comunicacao_beneficiario": 16,
      //     "total":80
      //   }],
      //   "erros": [],
      //   "mensagem": "Busca feita com sucesso",
      //   "sucesso": "true"
      //   }
    }
  },
  beforeCreate(){
    if(!this.$store.state.userData.userData.PermissaoAcoes.autorizador.includes('getmonitoramento')) {
        if(this.$store.state.userData.userData.PermissaoAcoes.autorizador.includes('getextratosolicitacoes')){
          this.$router.push('/autorizacao/extratodesolicitacao')
        } else {
          this.$router.push('/')
        }
    }
  },
  methods: {
       ...mapActions('autorizador', [
      "setFilter",
      "getMonitoramento"
    ]),
    atualizarFiltro(filtro){
        let filtroData = Object.assign(this.filterData, filtro)
        this.setFilter(filtroData)
    },
    mudarAba(){
      this.visaoDetalhada = false
      this.$nextTick(()=>this.getDadosMonitoramento(this.filterData))
    },
    getDadosMonitoramento(filterData) {
        this.filterData = filterData
        let opts = {
          periodo: this.tab==0? 'dia' : 'mes',
          ...filterData
        }
      this.getMonitoramento(opts).then(resp=> {
        this.dataReferencia = resp.data_referencia
        this.autorizacoes[opts.periodo] = resp && resp.autorizacoes? resp.autorizacoes : []
        this.transacoes[opts.periodo] = resp && resp.transacoes? resp.transacoes : []
      })
    },
    temPermissaoCarteira(){
          this.$store.dispatch("recebiveis/verificaPermissaoCarteiras").then(resp => this.filtrarPorCarteiras = resp)
        },
  },
};
</script>

<style>

</style>
